<div class="w-full">
  <!--BLUE BAR-->
  <div class="horiz-bar bg-primary"></div>
  <!--TITLE-->
  <div class="flex justify-content-between align-items-center flex-wrap mb-4 mt-4">
    <div class="flex justify-content-between align-items-center">
      <div class="text-800 text-3xl font-medium mr-4">{{ 'STANDARD_MYOPIA_PROGRESSION_TITLE' | translate }}</div>
      <p-button label="References" [outlined]="true" severity="secondary" size="small" class="ml-2"
        styleClass="text-xs px-3 py-1 border-gray-300 text-gray-600 hover:bg-gray-50" (onClick)="showReferences()">
      </p-button>
      <div class="border-round-2xl px-2 py-1 ml-2" style="background-color: grey; color: white">{{ progressionTypeLabel
        }}</div>
    </div>
  </div>

  @if(showExtrapolationWarning){
  <div class="flex align-items-center gap-2 mb-4">
    <span class="text-sm"> ⚠️ {{"EXTRAPOLATION_PROGRESSION_WARNING"| translate}}</span>
  </div>
  } @if(showExtrapolationWarning == false && selectedEyeProgressionStat != null){
  <div class="flex align-items-center gap-2 mb-4">
    <span class="mb-2 text-sm"> {{"NO_EXTRAPOLATION_TEXT"| translate}}</span>
  </div>
  }

  <!--ROW 1-->

  <div>
    <div class="flex mb-4">
      <div class="flex-1">{{"AGE_RANGE_PROGRESSION"| translate}}</div>
      <div class="flex-1 text-xl font-semibold">{{ ageAtComparisonVisitLabel ?? "N/A"}} → {{ageAtLatestVisitLabel ??
        "N/A"}}</div>
    </div>

    <div class="flex mb-4">
      <div class="flex-1">{{"REFRACTIVE_ERROR_PROGRESSION_DASH"| translate}}</div>
      <div class="flex-1 text-xl font-semibold">{{ serLabel }}</div>
    </div>
    @if(showNonCycloWarning){
    <div class="flex align-items-center gap-2 mb-4">
      <span class="text-sm"> ⚠️ {{"NON_CYLCO_PROGRESSION_WARNING"| translate}}</span>
    </div>
    }
    <div class="flex mb-4">
      <div class="flex-1">{{"AXIAL_PROGRESSION_DASH"| translate}}</div>
      <div class="flex-1 text-xl font-semibold">{{ alLabel }}</div>
    </div>
    @if(showKValueWarning){
    <div class="flex align-items-center gap-2">
      <span class="text-sm"> ⚠️ {{"K_VALUE_USED_FOR_CALC_WARNING"| translate}}</span>
    </div>
    }
  </div>
</div>

<div class="flex justify-content-end mt-4">
  <p-dropdown [options]="eyeSideDropDownChoices" [ngModel]="eyeSideSelected" (onChange)="onEyeSideChange($event)"
    optionLabel="label" placeholder="eye" placeholder="Select Eye Side">
  </p-dropdown>
</div>

<div class="mt-4">
  <p-accordion [activeIndex]="null">
    <p-accordionTab [header]="'COMPARATIVE_SER_DATA' | translate">
      <app-comparative-ser-data [ethnicity]="ethnicity"
        (ethnicityChanged)="ethnicityFromCompartiveDidChange($event)"></app-comparative-ser-data>
    </p-accordionTab>
    <p-accordionTab [header]="'COMPARATIVE_AXIAL_DATA' | translate">
      <app-comparative-axial-data [ethnicity]="ethnicity"
        (ethnicityChanged)="ethnicityFromCompartiveDidChange($event)"></app-comparative-axial-data>
    </p-accordionTab>
  </p-accordion>
</div>

<div class="horiz-bar-thin bg-gray-200 mt-4 mb-4"></div>

<!-- References Dialog -->
<p-dialog header="🔬 Scientific References" [(visible)]="showReferencesDialog" [modal]="true" [style]="{width: '50vw'}"
  [draggable]="false" [resizable]="false" (onHide)="hideReferences()">
  <app-references></app-references>
</p-dialog>